import { render, staticRenderFns } from "./formgen.vue?vue&type=template&id=bcf45fc0"
import script from "./formgen.vue?vue&type=script&lang=js"
export * from "./formgen.vue?vue&type=script&lang=js"
import style0 from "../../../css/vfg.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.min.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports